// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/*Statndard modules*/

import Vue from 'vue'
import Vuex from 'vuex'
import ElementUI from 'element-ui'
import Vue2Filters from 'vue2-filters'
import locale from 'element-ui/lib/locale/lang/en'

import {
  ServerTable,
  ClientTable,    
  Event
} from 'vue-tables-2'
import moment from 'moment'
import VueClip from 'vue-clip'
import VueCoreImageUpload from 'vue-image-crop-upload'
import VueMomentJS from 'vue-momentjs'
import VueLocalStorage from 'vue-localstorage'
import wysiwyg from 'vue-wysiwyg'

import promise from 'es6-promise-promise'

/*import VueAxios from 'vue-axios'*/

import App from './App'
import router from './router'
import Header from './components/header/header.vue'
/*import Sidebar from './components/sidebar/sidebar.vue'*/

import Sidebar from './components/location-pool-selector-sidebar/location-pool-selector.vue'
import Footer from './components/footer/footer.vue'
import Notification_Sidebar from './components/NotificationSidebar/notification_sidebar.vue'

/*End standard modules*/

// your config here

// create a root instance

/* js loading section other modules*/

import js_loader from './loader_modules/js_loader.js'

/*End js loading section*/

/*Style loading section*/

import style_loader from './loader_modules/style_loader.js'

/*End Style loading section*/

import ajaxconf from './Http_Config/ajax.conf.js'

Vue.config.productionTip = false

/* eslint-disable no-new */

/*Dependency injection vue modules*/

Vue.use(wysiwyg, {})
Vue.use(VueClip)
/*Vue.use(VueAxios, axios)*/
Vue.use(Vue2Filters)
import filter from './filters/filters.js'
Vue.use(VueLocalStorage)
Vue.component('vue-core-image-upload', VueCoreImageUpload)
Vue.use(ElementUI, {
  locale
})

Vue.use(VueMomentJS, moment) 
//OLD VERSION 0.6.99 of vue-tables-2 with custom table
  //Vue.use(ClientTable, {}, false, require('./templates/table/template.js')('client'))
//OLD VERSION 0.6.99 of vue-tables-2 with default template
  //Vue.use(ClientTable, {}, false, require('../node_modules/vue-tables-2/compiled/template.js')('client'))
//NEW VERSION 1.4.70 of vue-tables-2 with default template
  Vue.use(ClientTable);
/*End dependency injection*/

/*Router redirection on token not present*/

router.afterEach((to, from, next) => {

  /*  initTooltip(to.name)*/
  full_screen(to.name)
  if (localStorage.getItem('authentication')) {
    var auth = JSON.parse(localStorage.getItem('authentication'))
    window.authDetails = auth
  } else {
    window.authDetails = ''
  }


  if (auth) {
    //FG - FOOF - 20200811-FG-0001
    // TRY THIS TO MAKE THE AQUATICS DIR.
        //  CHANGE THEIR PASSWORD BEFORE DISPLAYING THE SIGNUP CONFIRM FORM
        //  (i.e. the email says first time you'll be asked to chg pw)
    if(auth.access_token) {
       if (auth.ForceUpdatePassword == "True" && auth.IsFirstLogin == "True") {
        context.$router.push('/resetpassword?code=' + code + '&Username=' + auth.email);
        return;
      }
    }
    //FG - FOOF - ABOVE

    //FG - FOOF - 20200811-FG-0001
    //if (auth.access_token) { <-- ORIG LINE
    if (auth.access_token && auth.ForceUpdatePassword != "True") { 
      window.authDetails = auth
      if (auth.FirstName) {
        router.app.$on('reloadAuth', (data) => {

          window.userName = auth.FirstName + ' ' + auth.LastName
        })
        window.userName = auth.FirstName + ' ' + auth.LastName

        /********************************************************************************************
        * FG - FOOF - After Cert - First Release (7) - First Release Security
        * A security "module" was created for the first release (feb 2021)
        * The line below makes sure the security rules remain in place when a page is reloaded
        * *****************************************************************************************/
        window.securityRules=JSON.parse(auth.SecurityRules)
      }

      if (!auth.FirstName && auth.role == 'AquaticsDirector') {
        router.push('/signupconfirm?OrganizationName=' + auth.OrganizationName)
      } else {
        // router.push('/AdminDashboard') //FG - FOOF - THIS WAS COMMENTED OUT IN THE ORIG. CODE
      }

    } else {

      router.push('login')
    }

  } else {

    var forceupdate = ''
    if (auth) {

      forceupdate = auth.ForceUpdatePassword
      if (forceupdate == 'True') {
        var forceupdate = 'False'

        router.push('login')
      }
    } else {
      if (to.name != 'login' && to.name != 'signup' && to.name != 'PersonalPostSignup' && to.name != 'resetpassword') {
        router.push('login')
      }

    }

  }

})

/*End Router redirection on token not present*/

/*Injecting main vue container*/
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})

/*Loading sidebar , header , footer*/




$('.page-link').click(function () {

})



// method to make the table full screen
function full_screen(routeName) {
  if (routeName == 'dashboard') {

    setTimeout(function () {

      if ($('.x_title').find('button').length == 1) {

        $('.x_title').append('<span class="fa fa-expand full_screen_icon"></span>')
        $('.full_screen_icon').css({
          'right': '93px',
          'bottom': '44px'
        })

      } else if (routeName == 'chemicalsettings') {
        $('.x_title').append('<span class="fa fa-expand full_screen_icon"></span>')
        $('.full_screen_icon').css({
          'right': '93px',
          'bottom': '28px'
        })
      } else {
        //FG - FOOF - After Cert - First Release - (2) - Do not show the expand icon (upper right for activity calendar on dashboard)
        //$('.x_title').append('<span class="fa fa-expand full_screen_icon"></span>') //<---line before "After Cert change"
        $('.x_title').not('.foof_no_expand_icon').append('<span class="fa fa-expand full_screen_icon"></span>')
      }
    

      $('.full_screen_icon').click(function () {

        $('body').append('<div class="overlay1"></div>')

        $(this).parent().parent().parent().find('.x_title').addClass('popup_header')
        $(this).parent().parent().parent().find('.x_title').append('<span class="close_button" aria-hidden="true">×</span>')
        $(this).parent().parent().parent().find('.table-responsive').addClass('max_height')
        $(this).parent().parent().parent().find('.x_panel').addClass('popup_no_padding')

        var context = this
        /*var topP = $(context).parent().parent().parent().offset().top - 200*/
        if (routeName == 'dashboard') {
          $(context).parent().parent().parent().addClass('full_screen')

          $(context).hide()
        } else if (routeName == 'certificates') {

          $(context).closest('.x_content').parent().addClass('full_screen')
          $(context).hide()
        } else {
          $(context).parent().parent().addClass('full_screen')
          $(context).hide()

        }
        /*   $('html, body').animate({
         scrollTop: 0
         }, 600)*/

        $('.overlay1 , .close_button').click(function () {

          if (routeName == 'dashboard') {

            $(context).parent().parent().parent().removeClass('full_screen')
            $(this).parent().parent().parent().find('.x_title').removeClass('popup_header')
            $(this).parent().parent().parent().find('.x_panel').removeClass('popup_no_padding')
          } else if (routeName == 'certificates') {
            $(context).closest('.x_content').parent().removeClass('full_screen')
          } else {

            $(context).parent().parent().removeClass('full_screen')
          }
          $(context).show()
          $('.overlay1').remove()
          $('.close_button').remove()

        })
        initTooltip()
      })

    }, 1000)
  }
}

var SidebarComponent = Vue.extend({
  router
})


var SidebarComponent = Vue.extend({
  router
})
new SidebarComponent(Sidebar).$mount('#sidebar')

var HeaderComponent = Vue.extend({
  router
})
new HeaderComponent(Header).$mount('#header')

var FooterComponent = Vue.extend({
  router
})
new FooterComponent(Footer).$mount('#footer')

var NotificationSidebar = Vue.extend({
  router
})
new NotificationSidebar(Notification_Sidebar).$mount('#notification_sidebar')



// WEBPACK FOOTER //
// ./src/main.js